import { useContext, useState} from "react";
import UserApi from "../api/UserApi";
import RtlProvider from "../Components/RtlProvider";
import { ContextNotification, severitys } from '../App';
import { ListItemButton, ListItemText, Typography } from "@mui/material";
import enumMapper from "../enumMapper";

const RoleSelecting = ({roleInfo}) => {
     const { open, setOpen } = useContext(ContextNotification);
    const [loading, setLoading] = useState(false);

    const handleSelectRole = (selectedRole) => {
        setLoading(true);
        UserApi.Login(roleInfo.username, roleInfo.password, enumMapper.AppId.GuestService, selectedRole).then((res) => {
            localStorage.setItem("token", res.data.access_token);
            window.location.pathname = "/dashboard";
        })
            .catch(err => {
                if (err.response && err.response.data) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                }
                else if (err.response && err.response.data && err.response.data.errors) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
                else if (err.message) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                }
            }).finally(() => setLoading(false))
    }
return (
    <>
 <RtlProvider>
        <Typography  sx={{ display: "flex", marginTop: 2, marginBottom: 1, alignItems: "center", padding: 1 }}>
         لطفا سمت مورد نظر خود را انتخاب کنید:
        </Typography>
        {
            
            roleInfo.roleIDS?.map((role)=>{
            return(
                <div key={role.id} >
                        <ListItemButton onClick={() => handleSelectRole(role.id )} sx={{textAlign:'center'}}>
                            <ListItemText component="h5" variant="h5"   primary={role.title} sx={{ alignItems: "center", backgroundColor: 'rgb(113 185 172 / 41%)',
                                 padding: 2, borderTop: 'solid 1px rgb(28 117 101 / 41%)', borderBottom: 'solid 1px rgb(28 117 101 / 41%)'
                                 , borderRight: 'solid 1px rgb(28 117 101 / 41%)', borderBottom: 'solid 1px rgb(28 117 101 / 41%)'
                                 , borderLeft: 'solid 1px rgb(28 117 101 / 41%)', borderBottom: 'solid 1px rgb(28 117 101 / 41%)'}} /> 
                        </ListItemButton>
            </div>
            )

           })
        }
       
        
       </RtlProvider>
    </>
);
}
export default RoleSelecting;